module.exports = __webpack_public_path__ + "img/start-now.a44bc652.svg";